import { useTheme } from "src/hooks";
import ChecklistItem from "./ChecklistItem";
import ChecklistDescription from "../../ChecklistDescription";

interface Props {
  checkLists: any[];
}

const CheckLists = ({ checkLists }: Props) => {
  const theme = useTheme() as any;
  return (
    <div
      style={{
        padding: "10px",
        display: "flex",
        flexDirection: "column",
        gap: "15px",
        border: `1px solid ${theme.colors.grayText}`,
        margin: "18px",
      }}>
      <p style={{ fontSize: "20px", fontWeight: 600 }}>Checklists</p>
      <div style={{ display: "flex", flexWrap: "wrap", gap: "20px" }}>
        {checkLists.map((checklist, index) => (
          <div
            className="entry"
            key={`checklist-${index}`}
            style={{
              border: `1px solid ${theme.colors.main[9]}`,
              padding: "12px",
              flex: 1,
              minWidth: "300px",
              maxWidth: "max-content",
            }}>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <p style={{ fontSize: "18px", margin: 0, fontWeight: 600 }}>
                {checklist.name}
              </p>
              <p
                style={{
                  fontSize: "15px",
                  margin: 0,
                  fontWeight: 600,
                  opacity: 0.7,
                }}>
                (v{checklist.version})
              </p>
            </div>

            <ChecklistDescription
              desc={checklist.description}
              noscroll={true}
              styles={{ margin: 0, opacity: 0.7 }}
            />
            <div
              style={{
                marginTop: "6px",
                display: "flex",
                flexDirection: "column",
                gap: "6px",
              }}>
              {checklist.list.map((item: any, i: number) =>
                item.text ? (
                  <ChecklistItem key={`item-${i}`} {...item} />
                ) : (
                  <div
                    key={`items-${i}`}
                    style={{
                      display: "flex",
                      gap: "8px",
                      marginLeft: "10px",
                      flexDirection: "column",
                    }}>
                    <p style={{ fontWeight: 700 }}>{item.name}</p>
                    {item.items.map((item: any, j: number) => (
                      <ChecklistItem key={`c-item-${j}`} {...item} />
                    ))}
                  </div>
                ),
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
export default CheckLists;
